import React from 'react'
import styled from 'styled-components'

import { DeviceMaintenanceTrendGroup, DeviceMetric } from 'types/DeviceMetric'

type Props = {
  hideRanges: boolean
  metricAndGroupListItem: DeviceMaintenanceTrendGroup | DeviceMetric
}

const isMetric = (item: DeviceMaintenanceTrendGroup | DeviceMetric): item is DeviceMetric => {
  return (item as DeviceMetric).metricId !== undefined
}

const TrendMetricsOverview = ({ hideRanges, metricAndGroupListItem }: Props) => {
  if (!metricAndGroupListItem || metricAndGroupListItem.showInTooltip) { return null }

  let range = ''
  if (isMetric(metricAndGroupListItem)) {
    if (metricAndGroupListItem.chart) {
      range = `${parseFloat(metricAndGroupListItem.chart.lowGreen)} to ${parseFloat(metricAndGroupListItem.chart.highGreen)}`
    }
  } else {
    range = metricAndGroupListItem.range
  }

  return (
    <S.MetricsInfo>
      <S.Metric>
        <S.InfoContent>
          <h5>Description:</h5>

          {metricAndGroupListItem.description
            ? metricAndGroupListItem.description.split(/\n/).map(value => <p key={value}>{value}</p>)
            : <p>--</p>
          }
        </S.InfoContent>

        {!hideRanges && range !== '' &&
          <S.InfoContent>
            <h5>Recommended Range:</h5>
            <S.Range>{range}</S.Range>
          </S.InfoContent>
        }

        {metricAndGroupListItem.callToAction && metricAndGroupListItem.callToAction.length > 0 &&
          <S.InfoContent>
            <h5>Call to Action:</h5>

            <S.List itemsCount={metricAndGroupListItem.callToAction?.length ?? 0}>
              {
                metricAndGroupListItem.callToAction.map(({ description, details }) =>
                  (
                    <div key={description}>
                      <li>{description}</li>
                      {details && <S.DetailsList> {details.map(detail => <li key={detail}>{detail}</li>)}</S.DetailsList>}
                    </div>
                  )
                )
              }
            </S.List>
          </S.InfoContent>
        }
      </S.Metric>
    </S.MetricsInfo>
  )
}

export default TrendMetricsOverview

const S = {
  MetricsInfo: styled.div`
    display: flex;
    margin: auto 35px;
    gap: 30px;
  `,
  Metric: styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
  `,
  InfoContent: styled.div`
    padding: 10px 0px 0px 0px;

    & > h5 {
      text-transform: capitalize;
      margin: 0;
      padding-left: 5px;
    }
      
    & > p {
      margin: 0;
      padding: 10px 0px 0px 5px;
    }
  `,
  Range: styled.p`
    padding-top: 10px;
  `,
  List: styled.ul.withConfig({
    shouldForwardProp: (prop) => !['itemsCount'].includes(prop)
  }) <{ itemsCount: number }>`
    list-style-type: ${({ itemsCount }) => itemsCount > 1 ? 'disc' : 'none'};
    list-style-position: inside;
    padding-bottom: 10px;
    padding-left: 10px;
    margin: 0;
  `,
  DetailsList: styled.ul`
    list-style-position: inside;
    padding-left: 10px;
  `
}
